import React from "react";
import PropTypes from "prop-types";

export default function Audience(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1212 6.87857C12.2928 8.05014 12.2928 9.94964 11.1212 11.1212C9.94964 12.2928 8.05014 12.2928 6.87857 11.1212C5.707 9.94964 5.707 8.05014 6.87857 6.87857C8.05014 5.707 9.94964 5.707 11.1212 6.87857Z"
        fill={props.fill}
      />
      <path
        d="M18 8H15.9202C15.4796 4.94092 13.0591 2.52045 10 2.07983V0H8V2.07983C4.94092 2.52044 2.52045 4.94091 2.07983 8H0V10H2.07983C2.52044 13.0591 4.94091 15.4795 8 15.9202V18H10V15.9202C13.0591 15.4796 15.4795 13.0591 15.9202 10H18V8ZM9 14C6.24316 14 4 11.7568 4 9C4 6.24316 6.24316 4 9 4C11.7568 4 14 6.24316 14 9C14 11.7568 11.7568 14 9 14Z"
        fill={props.fill}
      />
    </svg>
  );
}
Audience.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
Audience.defaultProps = {
  className: "",
  fill: "#93ABCA",
  width: 18,
  height: 18
};
